import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ItemLocationDetailFragmentDoc } from '../fragments/itemLocationDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchItemLocationsQueryVariables = Types.Exact<{
  search_term: Types.Scalars['String'];
  type?: Types.InputMaybe<Types.Scalars['String']>;
  event_id?: Types.InputMaybe<Types.Scalars['String']>;
  include_disabled?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type SearchItemLocationsQuery = { __typename?: 'Query', searchItemLocations: Array<{ __typename?: 'ItemLocation', id: string, name: string, type?: string | null, disabled_at?: string | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null }> };


export const SearchItemLocationsDocument = gql`
    query SearchItemLocations($search_term: String!, $type: String, $event_id: String, $include_disabled: Boolean) {
  searchItemLocations(
    search_term: $search_term
    type: $type
    event_id: $event_id
    include_disabled: $include_disabled
  ) {
    ...ItemLocationDetail
  }
}
    ${ItemLocationDetailFragmentDoc}`;

/**
 * __useSearchItemLocationsQuery__
 *
 * To run a query within a React component, call `useSearchItemLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchItemLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchItemLocationsQuery({
 *   variables: {
 *      search_term: // value for 'search_term'
 *      type: // value for 'type'
 *      event_id: // value for 'event_id'
 *      include_disabled: // value for 'include_disabled'
 *   },
 * });
 */
export function useSearchItemLocationsQuery(baseOptions: Apollo.QueryHookOptions<SearchItemLocationsQuery, SearchItemLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchItemLocationsQuery, SearchItemLocationsQueryVariables>(SearchItemLocationsDocument, options);
      }
export function useSearchItemLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchItemLocationsQuery, SearchItemLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchItemLocationsQuery, SearchItemLocationsQueryVariables>(SearchItemLocationsDocument, options);
        }
export type SearchItemLocationsQueryHookResult = ReturnType<typeof useSearchItemLocationsQuery>;
export type SearchItemLocationsLazyQueryHookResult = ReturnType<typeof useSearchItemLocationsLazyQuery>;
export type SearchItemLocationsQueryResult = Apollo.QueryResult<SearchItemLocationsQuery, SearchItemLocationsQueryVariables>;